// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Surgeon from '@/components/pages/Surgeons/Surgeon.vue'
import EditSurgeon from '@/components/pages/Surgeons/EditSurgeon.vue'

export default {
  path: '/surgeons',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      redirect: '/users'
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Surgeon,
          props: true,
          name: 'view-surgeon'
        },
        {
          path: 'edit',
          component: EditSurgeon,
          props: true,
          name: 'edit-surgeon',
          meta: {breadcrumb: 'Edit Surgeon'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/surgeons.js